"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  rpc: {
    getValue: {
      description: 'Retrieves the oracle value for a given key.',
      params: [{
        name: 'providerId',
        type: 'RpcDataProviderId'
      }, {
        name: 'key',
        type: 'OracleKey'
      }],
      type: 'Option<TimestampedValue>'
    },
    getAllValues: {
      description: 'Retrieves all oracle values.',
      params: [{
        name: 'providerId',
        type: 'RpcDataProviderId'
      }],
      type: 'Vec<(OracleKey, Option<TimestampedValue>)>'
    }
  },
  types: {
    RpcDataProviderId: 'Text',
    DataProviderId: 'u8',
    TimestampedValue: {
      value: 'OracleValue',
      timestamp: 'Moment'
    },
    TimestampedValueOf: 'TimestampedValue',
    OrderedSet: 'Vec<AccountId>'
  }
};
exports.default = _default;